import Model from "@/models/Model";

export default class Seen extends Model {
    resource() {
        return "seen";
    }

    baseURL() {
        return super.baseURL() + "/journal";
    }
}
